/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyLegacyRouteImport } from './routes/privacy-legacy'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConfirmEmailRouteImport } from './routes/confirm-email'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SignupIndexRouteImport } from './routes/signup/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as SignupSignup_typeRouteImport } from './routes/signup/$signup_type'
import { Route as ReturnSubpageRouteImport } from './routes/return/$subpage'
import { Route as LoginSubpageRouteImport } from './routes/login/$subpage'
import { Route as BlogPost_slugRouteImport } from './routes/blog/$post_slug'
import { Route as AppTournamentsChoiceRouteImport } from './routes/_app/tournaments-choice'
import { Route as AppGlobalRankingLeagueRouteImport } from './routes/_app/global-ranking-league'
import { Route as AppComingSoonRouteImport } from './routes/_app/coming-soon'
import { Route as AppTournamentsIndexRouteImport } from './routes/_app/tournaments/index'
import { Route as AppTournamentsRankingIndexRouteImport } from './routes/_app/tournaments-ranking/index'
import { Route as AppTournamentsRankingTablesIndexRouteImport } from './routes/_app/tournaments-ranking-tables/index'
import { Route as AppRunningIndexRouteImport } from './routes/_app/running/index'
import { Route as AppProfileIndexRouteImport } from './routes/_app/profile/index'
import { Route as AppPlayersIndexRouteImport } from './routes/_app/players/index'
import { Route as AppMessagesIndexRouteImport } from './routes/_app/messages/index'
import { Route as AppMarketplaceIndexRouteImport } from './routes/_app/marketplace/index'
import { Route as AppLeaguesIndexRouteImport } from './routes/_app/leagues/index'
import { Route as AppCommunitiesIndexRouteImport } from './routes/_app/communities/index'
import { Route as AppClubsIndexRouteImport } from './routes/_app/clubs/index'
import { Route as AppAbilitiesIndexRouteImport } from './routes/_app/abilities/index'
import { Route as AppTournamentsTournament_uidRouteImport } from './routes/_app/tournaments/$tournament_uid'
import { Route as AppTournamentsRankingRanking_group_uidRouteImport } from './routes/_app/tournaments-ranking/$ranking_group_uid'
import { Route as AppTournamentsRankingTablesRanking_group_uidRouteImport } from './routes/_app/tournaments-ranking-tables/$ranking_group_uid'
import { Route as AppRunningUploadRouteImport } from './routes/_app/running/upload'
import { Route as AppProfileUpcomingGamesRouteImport } from './routes/_app/profile/upcoming-games'
import { Route as AppProfileRecentMatchesRouteImport } from './routes/_app/profile/recent-matches'
import { Route as AppProfileMessagesRouteImport } from './routes/_app/profile/messages'
import { Route as AppPlayersPlayer_uidRouteImport } from './routes/_app/players/$player_uid'
import { Route as AppMasterUsersRouteImport } from './routes/_app/master/users'
import { Route as AppMasterSubscriptionsRouteImport } from './routes/_app/master/subscriptions'
import { Route as AppMasterPostsRouteImport } from './routes/_app/master/posts'
import { Route as AppMasterPlayersRouteImport } from './routes/_app/master/players'
import { Route as AppMarketplaceCategoryRouteImport } from './routes/_app/marketplace/$category'
import { Route as AppLeaguesLeague_uidRouteImport } from './routes/_app/leagues/$league_uid'
import { Route as AppCourtsBookingSplatRouteImport } from './routes/_app/courts-booking/$'
import { Route as AppProfilesPlayer_uidIndexRouteImport } from './routes/_app/profiles/$player_uid/index'
import { Route as AppOrganizerCoachesIndexRouteImport } from './routes/_app/organizer/coaches/index'
import { Route as AppOrganizerAssessmentsIndexRouteImport } from './routes/_app/organizer/assessments/index'
import { Route as AppCommunitiesCommunity_uidIndexRouteImport } from './routes/_app/communities/$community_uid/index'
import { Route as AppClubsClub_uidIndexRouteImport } from './routes/_app/clubs/$club_uid/index'
import { Route as AppAbilitiesAssessment_uidIndexRouteImport } from './routes/_app/abilities/$assessment_uid/index'
import { Route as AppTournamentsTournament_uidPageRouteImport } from './routes/_app/tournaments/$tournament_uid.$page'
import { Route as AppRunningResultsImport_uidRouteImport } from './routes/_app/running/results.$import_uid'
import { Route as AppRunningLeaderboardsRanking_group_uidRouteImport } from './routes/_app/running/leaderboards.$ranking_group_uid'
import { Route as AppRunningLeaderboardsResultsRanking_group_uidRouteImport } from './routes/_app/running/leaderboards-results.$ranking_group_uid'
import { Route as AppProfilesPlayer_uidStatsRouteImport } from './routes/_app/profiles/$player_uid/stats'
import { Route as AppProfilesPlayer_uidEditRouteImport } from './routes/_app/profiles/$player_uid/edit'
import { Route as AppProfilesPlayer_uidDashboardRouteImport } from './routes/_app/profiles/$player_uid/dashboard'
import { Route as AppProfileGamesGame_uidRouteImport } from './routes/_app/profile/games.$game_uid'
import { Route as AppOrganizerCoachesCoach_uidRouteImport } from './routes/_app/organizer/coaches/$coach_uid'
import { Route as AppMasterUsersUser_uidRouteImport } from './routes/_app/master/users.$user_uid'
import { Route as AppMasterSubscriptionsPost_uidRouteImport } from './routes/_app/master/subscriptions.$post_uid'
import { Route as AppMasterPostsPost_uidRouteImport } from './routes/_app/master/posts.$post_uid'
import { Route as AppMasterPlayersPlayer_uidRouteImport } from './routes/_app/master/players.$player_uid'
import { Route as AppLeaguesLeague_uidPageRouteImport } from './routes/_app/leagues/$league_uid.$page'
import { Route as AppCommunitiesCommunity_uidEditRouteImport } from './routes/_app/communities/$community_uid/edit'
import { Route as AppClubsClub_uidEditRouteImport } from './routes/_app/clubs/$club_uid/edit'
import { Route as AppClubsClub_uidCourtsBookingRouteImport } from './routes/_app/clubs/$club_uid/courts-booking'
import { Route as AppClubsClub_uidBookingsRouteImport } from './routes/_app/clubs/$club_uid/bookings'
import { Route as AppClubsClub_uidCourtsIndexRouteImport } from './routes/_app/clubs/$club_uid/courts/index'
import { Route as AppTournamentsTournament_uidPageSubpageRouteImport } from './routes/_app/tournaments/$tournament_uid.$page.$subpage'
import { Route as AppLeaguesLeague_uidPlayerPlayer_uidRouteImport } from './routes/_app/leagues/$league_uid.player.$player_uid'
import { Route as AppLeaguesLeague_uidGameGame_uidRouteImport } from './routes/_app/leagues/$league_uid.game.$game_uid'
import { Route as AppLeaguesLeague_uidPageSubpageRouteImport } from './routes/_app/leagues/$league_uid.$page.$subpage'
import { Route as AppClubsClub_uidCourtsCourt_uidRouteImport } from './routes/_app/clubs/$club_uid/courts/$court_uid'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyLegacyRoute = PrivacyLegacyRouteImport.update({
  id: '/privacy-legacy',
  path: '/privacy-legacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiePolicyRoute = CookiePolicyRouteImport.update({
  id: '/cookie-policy',
  path: '/cookie-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmEmailRoute = ConfirmEmailRouteImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupIndexRoute = SignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupSignup_typeRoute = SignupSignup_typeRouteImport.update({
  id: '/signup/$signup_type',
  path: '/signup/$signup_type',
  getParentRoute: () => rootRouteImport,
} as any)
const ReturnSubpageRoute = ReturnSubpageRouteImport.update({
  id: '/return/$subpage',
  path: '/return/$subpage',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSubpageRoute = LoginSubpageRouteImport.update({
  id: '/login/$subpage',
  path: '/login/$subpage',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogPost_slugRoute = BlogPost_slugRouteImport.update({
  id: '/blog/$post_slug',
  path: '/blog/$post_slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTournamentsChoiceRoute = AppTournamentsChoiceRouteImport.update({
  id: '/tournaments-choice',
  path: '/tournaments-choice',
  getParentRoute: () => AppRoute,
} as any)
const AppGlobalRankingLeagueRoute = AppGlobalRankingLeagueRouteImport.update({
  id: '/global-ranking-league',
  path: '/global-ranking-league',
  getParentRoute: () => AppRoute,
} as any)
const AppComingSoonRoute = AppComingSoonRouteImport.update({
  id: '/coming-soon',
  path: '/coming-soon',
  getParentRoute: () => AppRoute,
} as any)
const AppTournamentsIndexRoute = AppTournamentsIndexRouteImport.update({
  id: '/tournaments/',
  path: '/tournaments/',
  getParentRoute: () => AppRoute,
} as any)
const AppTournamentsRankingIndexRoute =
  AppTournamentsRankingIndexRouteImport.update({
    id: '/tournaments-ranking/',
    path: '/tournaments-ranking/',
    getParentRoute: () => AppRoute,
  } as any)
const AppTournamentsRankingTablesIndexRoute =
  AppTournamentsRankingTablesIndexRouteImport.update({
    id: '/tournaments-ranking-tables/',
    path: '/tournaments-ranking-tables/',
    getParentRoute: () => AppRoute,
  } as any)
const AppRunningIndexRoute = AppRunningIndexRouteImport.update({
  id: '/running/',
  path: '/running/',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileIndexRoute = AppProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlayersIndexRoute = AppPlayersIndexRouteImport.update({
  id: '/players/',
  path: '/players/',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesIndexRoute = AppMessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketplaceIndexRoute = AppMarketplaceIndexRouteImport.update({
  id: '/marketplace/',
  path: '/marketplace/',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaguesIndexRoute = AppLeaguesIndexRouteImport.update({
  id: '/leagues/',
  path: '/leagues/',
  getParentRoute: () => AppRoute,
} as any)
const AppCommunitiesIndexRoute = AppCommunitiesIndexRouteImport.update({
  id: '/communities/',
  path: '/communities/',
  getParentRoute: () => AppRoute,
} as any)
const AppClubsIndexRoute = AppClubsIndexRouteImport.update({
  id: '/clubs/',
  path: '/clubs/',
  getParentRoute: () => AppRoute,
} as any)
const AppAbilitiesIndexRoute = AppAbilitiesIndexRouteImport.update({
  id: '/abilities/',
  path: '/abilities/',
  getParentRoute: () => AppRoute,
} as any)
const AppTournamentsTournament_uidRoute =
  AppTournamentsTournament_uidRouteImport.update({
    id: '/tournaments/$tournament_uid',
    path: '/tournaments/$tournament_uid',
    getParentRoute: () => AppRoute,
  } as any)
const AppTournamentsRankingRanking_group_uidRoute =
  AppTournamentsRankingRanking_group_uidRouteImport.update({
    id: '/tournaments-ranking/$ranking_group_uid',
    path: '/tournaments-ranking/$ranking_group_uid',
    getParentRoute: () => AppRoute,
  } as any)
const AppTournamentsRankingTablesRanking_group_uidRoute =
  AppTournamentsRankingTablesRanking_group_uidRouteImport.update({
    id: '/tournaments-ranking-tables/$ranking_group_uid',
    path: '/tournaments-ranking-tables/$ranking_group_uid',
    getParentRoute: () => AppRoute,
  } as any)
const AppRunningUploadRoute = AppRunningUploadRouteImport.update({
  id: '/running/upload',
  path: '/running/upload',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileUpcomingGamesRoute = AppProfileUpcomingGamesRouteImport.update({
  id: '/profile/upcoming-games',
  path: '/profile/upcoming-games',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRecentMatchesRoute = AppProfileRecentMatchesRouteImport.update({
  id: '/profile/recent-matches',
  path: '/profile/recent-matches',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileMessagesRoute = AppProfileMessagesRouteImport.update({
  id: '/profile/messages',
  path: '/profile/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppPlayersPlayer_uidRoute = AppPlayersPlayer_uidRouteImport.update({
  id: '/players/$player_uid',
  path: '/players/$player_uid',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterUsersRoute = AppMasterUsersRouteImport.update({
  id: '/master/users',
  path: '/master/users',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterSubscriptionsRoute = AppMasterSubscriptionsRouteImport.update({
  id: '/master/subscriptions',
  path: '/master/subscriptions',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterPostsRoute = AppMasterPostsRouteImport.update({
  id: '/master/posts',
  path: '/master/posts',
  getParentRoute: () => AppRoute,
} as any)
const AppMasterPlayersRoute = AppMasterPlayersRouteImport.update({
  id: '/master/players',
  path: '/master/players',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketplaceCategoryRoute = AppMarketplaceCategoryRouteImport.update({
  id: '/marketplace/$category',
  path: '/marketplace/$category',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaguesLeague_uidRoute = AppLeaguesLeague_uidRouteImport.update({
  id: '/leagues/$league_uid',
  path: '/leagues/$league_uid',
  getParentRoute: () => AppRoute,
} as any)
const AppCourtsBookingSplatRoute = AppCourtsBookingSplatRouteImport.update({
  id: '/courts-booking/$',
  path: '/courts-booking/$',
  getParentRoute: () => AppRoute,
} as any)
const AppProfilesPlayer_uidIndexRoute =
  AppProfilesPlayer_uidIndexRouteImport.update({
    id: '/profiles/$player_uid/',
    path: '/profiles/$player_uid/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOrganizerCoachesIndexRoute =
  AppOrganizerCoachesIndexRouteImport.update({
    id: '/organizer/coaches/',
    path: '/organizer/coaches/',
    getParentRoute: () => AppRoute,
  } as any)
const AppOrganizerAssessmentsIndexRoute =
  AppOrganizerAssessmentsIndexRouteImport.update({
    id: '/organizer/assessments/',
    path: '/organizer/assessments/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCommunitiesCommunity_uidIndexRoute =
  AppCommunitiesCommunity_uidIndexRouteImport.update({
    id: '/communities/$community_uid/',
    path: '/communities/$community_uid/',
    getParentRoute: () => AppRoute,
  } as any)
const AppClubsClub_uidIndexRoute = AppClubsClub_uidIndexRouteImport.update({
  id: '/clubs/$club_uid/',
  path: '/clubs/$club_uid/',
  getParentRoute: () => AppRoute,
} as any)
const AppAbilitiesAssessment_uidIndexRoute =
  AppAbilitiesAssessment_uidIndexRouteImport.update({
    id: '/abilities/$assessment_uid/',
    path: '/abilities/$assessment_uid/',
    getParentRoute: () => AppRoute,
  } as any)
const AppTournamentsTournament_uidPageRoute =
  AppTournamentsTournament_uidPageRouteImport.update({
    id: '/$page',
    path: '/$page',
    getParentRoute: () => AppTournamentsTournament_uidRoute,
  } as any)
const AppRunningResultsImport_uidRoute =
  AppRunningResultsImport_uidRouteImport.update({
    id: '/running/results/$import_uid',
    path: '/running/results/$import_uid',
    getParentRoute: () => AppRoute,
  } as any)
const AppRunningLeaderboardsRanking_group_uidRoute =
  AppRunningLeaderboardsRanking_group_uidRouteImport.update({
    id: '/running/leaderboards/$ranking_group_uid',
    path: '/running/leaderboards/$ranking_group_uid',
    getParentRoute: () => AppRoute,
  } as any)
const AppRunningLeaderboardsResultsRanking_group_uidRoute =
  AppRunningLeaderboardsResultsRanking_group_uidRouteImport.update({
    id: '/running/leaderboards-results/$ranking_group_uid',
    path: '/running/leaderboards-results/$ranking_group_uid',
    getParentRoute: () => AppRoute,
  } as any)
const AppProfilesPlayer_uidStatsRoute =
  AppProfilesPlayer_uidStatsRouteImport.update({
    id: '/profiles/$player_uid/stats',
    path: '/profiles/$player_uid/stats',
    getParentRoute: () => AppRoute,
  } as any)
const AppProfilesPlayer_uidEditRoute =
  AppProfilesPlayer_uidEditRouteImport.update({
    id: '/profiles/$player_uid/edit',
    path: '/profiles/$player_uid/edit',
    getParentRoute: () => AppRoute,
  } as any)
const AppProfilesPlayer_uidDashboardRoute =
  AppProfilesPlayer_uidDashboardRouteImport.update({
    id: '/profiles/$player_uid/dashboard',
    path: '/profiles/$player_uid/dashboard',
    getParentRoute: () => AppRoute,
  } as any)
const AppProfileGamesGame_uidRoute = AppProfileGamesGame_uidRouteImport.update({
  id: '/profile/games/$game_uid',
  path: '/profile/games/$game_uid',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizerCoachesCoach_uidRoute =
  AppOrganizerCoachesCoach_uidRouteImport.update({
    id: '/organizer/coaches/$coach_uid',
    path: '/organizer/coaches/$coach_uid',
    getParentRoute: () => AppRoute,
  } as any)
const AppMasterUsersUser_uidRoute = AppMasterUsersUser_uidRouteImport.update({
  id: '/$user_uid',
  path: '/$user_uid',
  getParentRoute: () => AppMasterUsersRoute,
} as any)
const AppMasterSubscriptionsPost_uidRoute =
  AppMasterSubscriptionsPost_uidRouteImport.update({
    id: '/$post_uid',
    path: '/$post_uid',
    getParentRoute: () => AppMasterSubscriptionsRoute,
  } as any)
const AppMasterPostsPost_uidRoute = AppMasterPostsPost_uidRouteImport.update({
  id: '/$post_uid',
  path: '/$post_uid',
  getParentRoute: () => AppMasterPostsRoute,
} as any)
const AppMasterPlayersPlayer_uidRoute =
  AppMasterPlayersPlayer_uidRouteImport.update({
    id: '/$player_uid',
    path: '/$player_uid',
    getParentRoute: () => AppMasterPlayersRoute,
  } as any)
const AppLeaguesLeague_uidPageRoute =
  AppLeaguesLeague_uidPageRouteImport.update({
    id: '/$page',
    path: '/$page',
    getParentRoute: () => AppLeaguesLeague_uidRoute,
  } as any)
const AppCommunitiesCommunity_uidEditRoute =
  AppCommunitiesCommunity_uidEditRouteImport.update({
    id: '/communities/$community_uid/edit',
    path: '/communities/$community_uid/edit',
    getParentRoute: () => AppRoute,
  } as any)
const AppClubsClub_uidEditRoute = AppClubsClub_uidEditRouteImport.update({
  id: '/clubs/$club_uid/edit',
  path: '/clubs/$club_uid/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppClubsClub_uidCourtsBookingRoute =
  AppClubsClub_uidCourtsBookingRouteImport.update({
    id: '/clubs/$club_uid/courts-booking',
    path: '/clubs/$club_uid/courts-booking',
    getParentRoute: () => AppRoute,
  } as any)
const AppClubsClub_uidBookingsRoute =
  AppClubsClub_uidBookingsRouteImport.update({
    id: '/clubs/$club_uid/bookings',
    path: '/clubs/$club_uid/bookings',
    getParentRoute: () => AppRoute,
  } as any)
const AppClubsClub_uidCourtsIndexRoute =
  AppClubsClub_uidCourtsIndexRouteImport.update({
    id: '/clubs/$club_uid/courts/',
    path: '/clubs/$club_uid/courts/',
    getParentRoute: () => AppRoute,
  } as any)
const AppTournamentsTournament_uidPageSubpageRoute =
  AppTournamentsTournament_uidPageSubpageRouteImport.update({
    id: '/$subpage',
    path: '/$subpage',
    getParentRoute: () => AppTournamentsTournament_uidPageRoute,
  } as any)
const AppLeaguesLeague_uidPlayerPlayer_uidRoute =
  AppLeaguesLeague_uidPlayerPlayer_uidRouteImport.update({
    id: '/player/$player_uid',
    path: '/player/$player_uid',
    getParentRoute: () => AppLeaguesLeague_uidRoute,
  } as any)
const AppLeaguesLeague_uidGameGame_uidRoute =
  AppLeaguesLeague_uidGameGame_uidRouteImport.update({
    id: '/game/$game_uid',
    path: '/game/$game_uid',
    getParentRoute: () => AppLeaguesLeague_uidRoute,
  } as any)
const AppLeaguesLeague_uidPageSubpageRoute =
  AppLeaguesLeague_uidPageSubpageRouteImport.update({
    id: '/$subpage',
    path: '/$subpage',
    getParentRoute: () => AppLeaguesLeague_uidPageRoute,
  } as any)
const AppClubsClub_uidCourtsCourt_uidRoute =
  AppClubsClub_uidCourtsCourt_uidRouteImport.update({
    id: '/clubs/$club_uid/courts/$court_uid',
    path: '/clubs/$club_uid/courts/$court_uid',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/contact': typeof ContactRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/faq': typeof FaqRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-legacy': typeof PrivacyLegacyRoute
  '/terms': typeof TermsRoute
  '/coming-soon': typeof AppComingSoonRoute
  '/global-ranking-league': typeof AppGlobalRankingLeagueRoute
  '/tournaments-choice': typeof AppTournamentsChoiceRoute
  '/blog/$post_slug': typeof BlogPost_slugRoute
  '/login/$subpage': typeof LoginSubpageRoute
  '/return/$subpage': typeof ReturnSubpageRoute
  '/signup/$signup_type': typeof SignupSignup_typeRoute
  '/blog': typeof BlogIndexRoute
  '/login': typeof LoginIndexRoute
  '/signup': typeof SignupIndexRoute
  '/courts-booking/$': typeof AppCourtsBookingSplatRoute
  '/leagues/$league_uid': typeof AppLeaguesLeague_uidRouteWithChildren
  '/marketplace/$category': typeof AppMarketplaceCategoryRoute
  '/master/players': typeof AppMasterPlayersRouteWithChildren
  '/master/posts': typeof AppMasterPostsRouteWithChildren
  '/master/subscriptions': typeof AppMasterSubscriptionsRouteWithChildren
  '/master/users': typeof AppMasterUsersRouteWithChildren
  '/players/$player_uid': typeof AppPlayersPlayer_uidRoute
  '/profile/messages': typeof AppProfileMessagesRoute
  '/profile/recent-matches': typeof AppProfileRecentMatchesRoute
  '/profile/upcoming-games': typeof AppProfileUpcomingGamesRoute
  '/running/upload': typeof AppRunningUploadRoute
  '/tournaments-ranking-tables/$ranking_group_uid': typeof AppTournamentsRankingTablesRanking_group_uidRoute
  '/tournaments-ranking/$ranking_group_uid': typeof AppTournamentsRankingRanking_group_uidRoute
  '/tournaments/$tournament_uid': typeof AppTournamentsTournament_uidRouteWithChildren
  '/abilities': typeof AppAbilitiesIndexRoute
  '/clubs': typeof AppClubsIndexRoute
  '/communities': typeof AppCommunitiesIndexRoute
  '/leagues': typeof AppLeaguesIndexRoute
  '/marketplace': typeof AppMarketplaceIndexRoute
  '/messages': typeof AppMessagesIndexRoute
  '/players': typeof AppPlayersIndexRoute
  '/profile': typeof AppProfileIndexRoute
  '/running': typeof AppRunningIndexRoute
  '/tournaments-ranking-tables': typeof AppTournamentsRankingTablesIndexRoute
  '/tournaments-ranking': typeof AppTournamentsRankingIndexRoute
  '/tournaments': typeof AppTournamentsIndexRoute
  '/clubs/$club_uid/bookings': typeof AppClubsClub_uidBookingsRoute
  '/clubs/$club_uid/courts-booking': typeof AppClubsClub_uidCourtsBookingRoute
  '/clubs/$club_uid/edit': typeof AppClubsClub_uidEditRoute
  '/communities/$community_uid/edit': typeof AppCommunitiesCommunity_uidEditRoute
  '/leagues/$league_uid/$page': typeof AppLeaguesLeague_uidPageRouteWithChildren
  '/master/players/$player_uid': typeof AppMasterPlayersPlayer_uidRoute
  '/master/posts/$post_uid': typeof AppMasterPostsPost_uidRoute
  '/master/subscriptions/$post_uid': typeof AppMasterSubscriptionsPost_uidRoute
  '/master/users/$user_uid': typeof AppMasterUsersUser_uidRoute
  '/organizer/coaches/$coach_uid': typeof AppOrganizerCoachesCoach_uidRoute
  '/profile/games/$game_uid': typeof AppProfileGamesGame_uidRoute
  '/profiles/$player_uid/dashboard': typeof AppProfilesPlayer_uidDashboardRoute
  '/profiles/$player_uid/edit': typeof AppProfilesPlayer_uidEditRoute
  '/profiles/$player_uid/stats': typeof AppProfilesPlayer_uidStatsRoute
  '/running/leaderboards-results/$ranking_group_uid': typeof AppRunningLeaderboardsResultsRanking_group_uidRoute
  '/running/leaderboards/$ranking_group_uid': typeof AppRunningLeaderboardsRanking_group_uidRoute
  '/running/results/$import_uid': typeof AppRunningResultsImport_uidRoute
  '/tournaments/$tournament_uid/$page': typeof AppTournamentsTournament_uidPageRouteWithChildren
  '/abilities/$assessment_uid': typeof AppAbilitiesAssessment_uidIndexRoute
  '/clubs/$club_uid': typeof AppClubsClub_uidIndexRoute
  '/communities/$community_uid': typeof AppCommunitiesCommunity_uidIndexRoute
  '/organizer/assessments': typeof AppOrganizerAssessmentsIndexRoute
  '/organizer/coaches': typeof AppOrganizerCoachesIndexRoute
  '/profiles/$player_uid': typeof AppProfilesPlayer_uidIndexRoute
  '/clubs/$club_uid/courts/$court_uid': typeof AppClubsClub_uidCourtsCourt_uidRoute
  '/leagues/$league_uid/$page/$subpage': typeof AppLeaguesLeague_uidPageSubpageRoute
  '/leagues/$league_uid/game/$game_uid': typeof AppLeaguesLeague_uidGameGame_uidRoute
  '/leagues/$league_uid/player/$player_uid': typeof AppLeaguesLeague_uidPlayerPlayer_uidRoute
  '/tournaments/$tournament_uid/$page/$subpage': typeof AppTournamentsTournament_uidPageSubpageRoute
  '/clubs/$club_uid/courts': typeof AppClubsClub_uidCourtsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/contact': typeof ContactRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/faq': typeof FaqRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-legacy': typeof PrivacyLegacyRoute
  '/terms': typeof TermsRoute
  '/coming-soon': typeof AppComingSoonRoute
  '/global-ranking-league': typeof AppGlobalRankingLeagueRoute
  '/tournaments-choice': typeof AppTournamentsChoiceRoute
  '/blog/$post_slug': typeof BlogPost_slugRoute
  '/login/$subpage': typeof LoginSubpageRoute
  '/return/$subpage': typeof ReturnSubpageRoute
  '/signup/$signup_type': typeof SignupSignup_typeRoute
  '/blog': typeof BlogIndexRoute
  '/login': typeof LoginIndexRoute
  '/signup': typeof SignupIndexRoute
  '/courts-booking/$': typeof AppCourtsBookingSplatRoute
  '/leagues/$league_uid': typeof AppLeaguesLeague_uidRouteWithChildren
  '/marketplace/$category': typeof AppMarketplaceCategoryRoute
  '/master/players': typeof AppMasterPlayersRouteWithChildren
  '/master/posts': typeof AppMasterPostsRouteWithChildren
  '/master/subscriptions': typeof AppMasterSubscriptionsRouteWithChildren
  '/master/users': typeof AppMasterUsersRouteWithChildren
  '/players/$player_uid': typeof AppPlayersPlayer_uidRoute
  '/profile/messages': typeof AppProfileMessagesRoute
  '/profile/recent-matches': typeof AppProfileRecentMatchesRoute
  '/profile/upcoming-games': typeof AppProfileUpcomingGamesRoute
  '/running/upload': typeof AppRunningUploadRoute
  '/tournaments-ranking-tables/$ranking_group_uid': typeof AppTournamentsRankingTablesRanking_group_uidRoute
  '/tournaments-ranking/$ranking_group_uid': typeof AppTournamentsRankingRanking_group_uidRoute
  '/tournaments/$tournament_uid': typeof AppTournamentsTournament_uidRouteWithChildren
  '/abilities': typeof AppAbilitiesIndexRoute
  '/clubs': typeof AppClubsIndexRoute
  '/communities': typeof AppCommunitiesIndexRoute
  '/leagues': typeof AppLeaguesIndexRoute
  '/marketplace': typeof AppMarketplaceIndexRoute
  '/messages': typeof AppMessagesIndexRoute
  '/players': typeof AppPlayersIndexRoute
  '/profile': typeof AppProfileIndexRoute
  '/running': typeof AppRunningIndexRoute
  '/tournaments-ranking-tables': typeof AppTournamentsRankingTablesIndexRoute
  '/tournaments-ranking': typeof AppTournamentsRankingIndexRoute
  '/tournaments': typeof AppTournamentsIndexRoute
  '/clubs/$club_uid/bookings': typeof AppClubsClub_uidBookingsRoute
  '/clubs/$club_uid/courts-booking': typeof AppClubsClub_uidCourtsBookingRoute
  '/clubs/$club_uid/edit': typeof AppClubsClub_uidEditRoute
  '/communities/$community_uid/edit': typeof AppCommunitiesCommunity_uidEditRoute
  '/leagues/$league_uid/$page': typeof AppLeaguesLeague_uidPageRouteWithChildren
  '/master/players/$player_uid': typeof AppMasterPlayersPlayer_uidRoute
  '/master/posts/$post_uid': typeof AppMasterPostsPost_uidRoute
  '/master/subscriptions/$post_uid': typeof AppMasterSubscriptionsPost_uidRoute
  '/master/users/$user_uid': typeof AppMasterUsersUser_uidRoute
  '/organizer/coaches/$coach_uid': typeof AppOrganizerCoachesCoach_uidRoute
  '/profile/games/$game_uid': typeof AppProfileGamesGame_uidRoute
  '/profiles/$player_uid/dashboard': typeof AppProfilesPlayer_uidDashboardRoute
  '/profiles/$player_uid/edit': typeof AppProfilesPlayer_uidEditRoute
  '/profiles/$player_uid/stats': typeof AppProfilesPlayer_uidStatsRoute
  '/running/leaderboards-results/$ranking_group_uid': typeof AppRunningLeaderboardsResultsRanking_group_uidRoute
  '/running/leaderboards/$ranking_group_uid': typeof AppRunningLeaderboardsRanking_group_uidRoute
  '/running/results/$import_uid': typeof AppRunningResultsImport_uidRoute
  '/tournaments/$tournament_uid/$page': typeof AppTournamentsTournament_uidPageRouteWithChildren
  '/abilities/$assessment_uid': typeof AppAbilitiesAssessment_uidIndexRoute
  '/clubs/$club_uid': typeof AppClubsClub_uidIndexRoute
  '/communities/$community_uid': typeof AppCommunitiesCommunity_uidIndexRoute
  '/organizer/assessments': typeof AppOrganizerAssessmentsIndexRoute
  '/organizer/coaches': typeof AppOrganizerCoachesIndexRoute
  '/profiles/$player_uid': typeof AppProfilesPlayer_uidIndexRoute
  '/clubs/$club_uid/courts/$court_uid': typeof AppClubsClub_uidCourtsCourt_uidRoute
  '/leagues/$league_uid/$page/$subpage': typeof AppLeaguesLeague_uidPageSubpageRoute
  '/leagues/$league_uid/game/$game_uid': typeof AppLeaguesLeague_uidGameGame_uidRoute
  '/leagues/$league_uid/player/$player_uid': typeof AppLeaguesLeague_uidPlayerPlayer_uidRoute
  '/tournaments/$tournament_uid/$page/$subpage': typeof AppTournamentsTournament_uidPageSubpageRoute
  '/clubs/$club_uid/courts': typeof AppClubsClub_uidCourtsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/about': typeof AboutRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/contact': typeof ContactRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/faq': typeof FaqRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-legacy': typeof PrivacyLegacyRoute
  '/terms': typeof TermsRoute
  '/_app/coming-soon': typeof AppComingSoonRoute
  '/_app/global-ranking-league': typeof AppGlobalRankingLeagueRoute
  '/_app/tournaments-choice': typeof AppTournamentsChoiceRoute
  '/blog/$post_slug': typeof BlogPost_slugRoute
  '/login/$subpage': typeof LoginSubpageRoute
  '/return/$subpage': typeof ReturnSubpageRoute
  '/signup/$signup_type': typeof SignupSignup_typeRoute
  '/blog/': typeof BlogIndexRoute
  '/login/': typeof LoginIndexRoute
  '/signup/': typeof SignupIndexRoute
  '/_app/courts-booking/$': typeof AppCourtsBookingSplatRoute
  '/_app/leagues/$league_uid': typeof AppLeaguesLeague_uidRouteWithChildren
  '/_app/marketplace/$category': typeof AppMarketplaceCategoryRoute
  '/_app/master/players': typeof AppMasterPlayersRouteWithChildren
  '/_app/master/posts': typeof AppMasterPostsRouteWithChildren
  '/_app/master/subscriptions': typeof AppMasterSubscriptionsRouteWithChildren
  '/_app/master/users': typeof AppMasterUsersRouteWithChildren
  '/_app/players/$player_uid': typeof AppPlayersPlayer_uidRoute
  '/_app/profile/messages': typeof AppProfileMessagesRoute
  '/_app/profile/recent-matches': typeof AppProfileRecentMatchesRoute
  '/_app/profile/upcoming-games': typeof AppProfileUpcomingGamesRoute
  '/_app/running/upload': typeof AppRunningUploadRoute
  '/_app/tournaments-ranking-tables/$ranking_group_uid': typeof AppTournamentsRankingTablesRanking_group_uidRoute
  '/_app/tournaments-ranking/$ranking_group_uid': typeof AppTournamentsRankingRanking_group_uidRoute
  '/_app/tournaments/$tournament_uid': typeof AppTournamentsTournament_uidRouteWithChildren
  '/_app/abilities/': typeof AppAbilitiesIndexRoute
  '/_app/clubs/': typeof AppClubsIndexRoute
  '/_app/communities/': typeof AppCommunitiesIndexRoute
  '/_app/leagues/': typeof AppLeaguesIndexRoute
  '/_app/marketplace/': typeof AppMarketplaceIndexRoute
  '/_app/messages/': typeof AppMessagesIndexRoute
  '/_app/players/': typeof AppPlayersIndexRoute
  '/_app/profile/': typeof AppProfileIndexRoute
  '/_app/running/': typeof AppRunningIndexRoute
  '/_app/tournaments-ranking-tables/': typeof AppTournamentsRankingTablesIndexRoute
  '/_app/tournaments-ranking/': typeof AppTournamentsRankingIndexRoute
  '/_app/tournaments/': typeof AppTournamentsIndexRoute
  '/_app/clubs/$club_uid/bookings': typeof AppClubsClub_uidBookingsRoute
  '/_app/clubs/$club_uid/courts-booking': typeof AppClubsClub_uidCourtsBookingRoute
  '/_app/clubs/$club_uid/edit': typeof AppClubsClub_uidEditRoute
  '/_app/communities/$community_uid/edit': typeof AppCommunitiesCommunity_uidEditRoute
  '/_app/leagues/$league_uid/$page': typeof AppLeaguesLeague_uidPageRouteWithChildren
  '/_app/master/players/$player_uid': typeof AppMasterPlayersPlayer_uidRoute
  '/_app/master/posts/$post_uid': typeof AppMasterPostsPost_uidRoute
  '/_app/master/subscriptions/$post_uid': typeof AppMasterSubscriptionsPost_uidRoute
  '/_app/master/users/$user_uid': typeof AppMasterUsersUser_uidRoute
  '/_app/organizer/coaches/$coach_uid': typeof AppOrganizerCoachesCoach_uidRoute
  '/_app/profile/games/$game_uid': typeof AppProfileGamesGame_uidRoute
  '/_app/profiles/$player_uid/dashboard': typeof AppProfilesPlayer_uidDashboardRoute
  '/_app/profiles/$player_uid/edit': typeof AppProfilesPlayer_uidEditRoute
  '/_app/profiles/$player_uid/stats': typeof AppProfilesPlayer_uidStatsRoute
  '/_app/running/leaderboards-results/$ranking_group_uid': typeof AppRunningLeaderboardsResultsRanking_group_uidRoute
  '/_app/running/leaderboards/$ranking_group_uid': typeof AppRunningLeaderboardsRanking_group_uidRoute
  '/_app/running/results/$import_uid': typeof AppRunningResultsImport_uidRoute
  '/_app/tournaments/$tournament_uid/$page': typeof AppTournamentsTournament_uidPageRouteWithChildren
  '/_app/abilities/$assessment_uid/': typeof AppAbilitiesAssessment_uidIndexRoute
  '/_app/clubs/$club_uid/': typeof AppClubsClub_uidIndexRoute
  '/_app/communities/$community_uid/': typeof AppCommunitiesCommunity_uidIndexRoute
  '/_app/organizer/assessments/': typeof AppOrganizerAssessmentsIndexRoute
  '/_app/organizer/coaches/': typeof AppOrganizerCoachesIndexRoute
  '/_app/profiles/$player_uid/': typeof AppProfilesPlayer_uidIndexRoute
  '/_app/clubs/$club_uid/courts/$court_uid': typeof AppClubsClub_uidCourtsCourt_uidRoute
  '/_app/leagues/$league_uid/$page/$subpage': typeof AppLeaguesLeague_uidPageSubpageRoute
  '/_app/leagues/$league_uid/game/$game_uid': typeof AppLeaguesLeague_uidGameGame_uidRoute
  '/_app/leagues/$league_uid/player/$player_uid': typeof AppLeaguesLeague_uidPlayerPlayer_uidRoute
  '/_app/tournaments/$tournament_uid/$page/$subpage': typeof AppTournamentsTournament_uidPageSubpageRoute
  '/_app/clubs/$club_uid/courts/': typeof AppClubsClub_uidCourtsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/confirm-email'
    | '/contact'
    | '/cookie-policy'
    | '/faq'
    | '/pricing'
    | '/privacy'
    | '/privacy-legacy'
    | '/terms'
    | '/coming-soon'
    | '/global-ranking-league'
    | '/tournaments-choice'
    | '/blog/$post_slug'
    | '/login/$subpage'
    | '/return/$subpage'
    | '/signup/$signup_type'
    | '/blog'
    | '/login'
    | '/signup'
    | '/courts-booking/$'
    | '/leagues/$league_uid'
    | '/marketplace/$category'
    | '/master/players'
    | '/master/posts'
    | '/master/subscriptions'
    | '/master/users'
    | '/players/$player_uid'
    | '/profile/messages'
    | '/profile/recent-matches'
    | '/profile/upcoming-games'
    | '/running/upload'
    | '/tournaments-ranking-tables/$ranking_group_uid'
    | '/tournaments-ranking/$ranking_group_uid'
    | '/tournaments/$tournament_uid'
    | '/abilities'
    | '/clubs'
    | '/communities'
    | '/leagues'
    | '/marketplace'
    | '/messages'
    | '/players'
    | '/profile'
    | '/running'
    | '/tournaments-ranking-tables'
    | '/tournaments-ranking'
    | '/tournaments'
    | '/clubs/$club_uid/bookings'
    | '/clubs/$club_uid/courts-booking'
    | '/clubs/$club_uid/edit'
    | '/communities/$community_uid/edit'
    | '/leagues/$league_uid/$page'
    | '/master/players/$player_uid'
    | '/master/posts/$post_uid'
    | '/master/subscriptions/$post_uid'
    | '/master/users/$user_uid'
    | '/organizer/coaches/$coach_uid'
    | '/profile/games/$game_uid'
    | '/profiles/$player_uid/dashboard'
    | '/profiles/$player_uid/edit'
    | '/profiles/$player_uid/stats'
    | '/running/leaderboards-results/$ranking_group_uid'
    | '/running/leaderboards/$ranking_group_uid'
    | '/running/results/$import_uid'
    | '/tournaments/$tournament_uid/$page'
    | '/abilities/$assessment_uid'
    | '/clubs/$club_uid'
    | '/communities/$community_uid'
    | '/organizer/assessments'
    | '/organizer/coaches'
    | '/profiles/$player_uid'
    | '/clubs/$club_uid/courts/$court_uid'
    | '/leagues/$league_uid/$page/$subpage'
    | '/leagues/$league_uid/game/$game_uid'
    | '/leagues/$league_uid/player/$player_uid'
    | '/tournaments/$tournament_uid/$page/$subpage'
    | '/clubs/$club_uid/courts'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/confirm-email'
    | '/contact'
    | '/cookie-policy'
    | '/faq'
    | '/pricing'
    | '/privacy'
    | '/privacy-legacy'
    | '/terms'
    | '/coming-soon'
    | '/global-ranking-league'
    | '/tournaments-choice'
    | '/blog/$post_slug'
    | '/login/$subpage'
    | '/return/$subpage'
    | '/signup/$signup_type'
    | '/blog'
    | '/login'
    | '/signup'
    | '/courts-booking/$'
    | '/leagues/$league_uid'
    | '/marketplace/$category'
    | '/master/players'
    | '/master/posts'
    | '/master/subscriptions'
    | '/master/users'
    | '/players/$player_uid'
    | '/profile/messages'
    | '/profile/recent-matches'
    | '/profile/upcoming-games'
    | '/running/upload'
    | '/tournaments-ranking-tables/$ranking_group_uid'
    | '/tournaments-ranking/$ranking_group_uid'
    | '/tournaments/$tournament_uid'
    | '/abilities'
    | '/clubs'
    | '/communities'
    | '/leagues'
    | '/marketplace'
    | '/messages'
    | '/players'
    | '/profile'
    | '/running'
    | '/tournaments-ranking-tables'
    | '/tournaments-ranking'
    | '/tournaments'
    | '/clubs/$club_uid/bookings'
    | '/clubs/$club_uid/courts-booking'
    | '/clubs/$club_uid/edit'
    | '/communities/$community_uid/edit'
    | '/leagues/$league_uid/$page'
    | '/master/players/$player_uid'
    | '/master/posts/$post_uid'
    | '/master/subscriptions/$post_uid'
    | '/master/users/$user_uid'
    | '/organizer/coaches/$coach_uid'
    | '/profile/games/$game_uid'
    | '/profiles/$player_uid/dashboard'
    | '/profiles/$player_uid/edit'
    | '/profiles/$player_uid/stats'
    | '/running/leaderboards-results/$ranking_group_uid'
    | '/running/leaderboards/$ranking_group_uid'
    | '/running/results/$import_uid'
    | '/tournaments/$tournament_uid/$page'
    | '/abilities/$assessment_uid'
    | '/clubs/$club_uid'
    | '/communities/$community_uid'
    | '/organizer/assessments'
    | '/organizer/coaches'
    | '/profiles/$player_uid'
    | '/clubs/$club_uid/courts/$court_uid'
    | '/leagues/$league_uid/$page/$subpage'
    | '/leagues/$league_uid/game/$game_uid'
    | '/leagues/$league_uid/player/$player_uid'
    | '/tournaments/$tournament_uid/$page/$subpage'
    | '/clubs/$club_uid/courts'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/about'
    | '/confirm-email'
    | '/contact'
    | '/cookie-policy'
    | '/faq'
    | '/pricing'
    | '/privacy'
    | '/privacy-legacy'
    | '/terms'
    | '/_app/coming-soon'
    | '/_app/global-ranking-league'
    | '/_app/tournaments-choice'
    | '/blog/$post_slug'
    | '/login/$subpage'
    | '/return/$subpage'
    | '/signup/$signup_type'
    | '/blog/'
    | '/login/'
    | '/signup/'
    | '/_app/courts-booking/$'
    | '/_app/leagues/$league_uid'
    | '/_app/marketplace/$category'
    | '/_app/master/players'
    | '/_app/master/posts'
    | '/_app/master/subscriptions'
    | '/_app/master/users'
    | '/_app/players/$player_uid'
    | '/_app/profile/messages'
    | '/_app/profile/recent-matches'
    | '/_app/profile/upcoming-games'
    | '/_app/running/upload'
    | '/_app/tournaments-ranking-tables/$ranking_group_uid'
    | '/_app/tournaments-ranking/$ranking_group_uid'
    | '/_app/tournaments/$tournament_uid'
    | '/_app/abilities/'
    | '/_app/clubs/'
    | '/_app/communities/'
    | '/_app/leagues/'
    | '/_app/marketplace/'
    | '/_app/messages/'
    | '/_app/players/'
    | '/_app/profile/'
    | '/_app/running/'
    | '/_app/tournaments-ranking-tables/'
    | '/_app/tournaments-ranking/'
    | '/_app/tournaments/'
    | '/_app/clubs/$club_uid/bookings'
    | '/_app/clubs/$club_uid/courts-booking'
    | '/_app/clubs/$club_uid/edit'
    | '/_app/communities/$community_uid/edit'
    | '/_app/leagues/$league_uid/$page'
    | '/_app/master/players/$player_uid'
    | '/_app/master/posts/$post_uid'
    | '/_app/master/subscriptions/$post_uid'
    | '/_app/master/users/$user_uid'
    | '/_app/organizer/coaches/$coach_uid'
    | '/_app/profile/games/$game_uid'
    | '/_app/profiles/$player_uid/dashboard'
    | '/_app/profiles/$player_uid/edit'
    | '/_app/profiles/$player_uid/stats'
    | '/_app/running/leaderboards-results/$ranking_group_uid'
    | '/_app/running/leaderboards/$ranking_group_uid'
    | '/_app/running/results/$import_uid'
    | '/_app/tournaments/$tournament_uid/$page'
    | '/_app/abilities/$assessment_uid/'
    | '/_app/clubs/$club_uid/'
    | '/_app/communities/$community_uid/'
    | '/_app/organizer/assessments/'
    | '/_app/organizer/coaches/'
    | '/_app/profiles/$player_uid/'
    | '/_app/clubs/$club_uid/courts/$court_uid'
    | '/_app/leagues/$league_uid/$page/$subpage'
    | '/_app/leagues/$league_uid/game/$game_uid'
    | '/_app/leagues/$league_uid/player/$player_uid'
    | '/_app/tournaments/$tournament_uid/$page/$subpage'
    | '/_app/clubs/$club_uid/courts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AboutRoute: typeof AboutRoute
  ConfirmEmailRoute: typeof ConfirmEmailRoute
  ContactRoute: typeof ContactRoute
  CookiePolicyRoute: typeof CookiePolicyRoute
  FaqRoute: typeof FaqRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  PrivacyLegacyRoute: typeof PrivacyLegacyRoute
  TermsRoute: typeof TermsRoute
  BlogPost_slugRoute: typeof BlogPost_slugRoute
  LoginSubpageRoute: typeof LoginSubpageRoute
  ReturnSubpageRoute: typeof ReturnSubpageRoute
  SignupSignup_typeRoute: typeof SignupSignup_typeRoute
  BlogIndexRoute: typeof BlogIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  SignupIndexRoute: typeof SignupIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-legacy': {
      id: '/privacy-legacy'
      path: '/privacy-legacy'
      fullPath: '/privacy-legacy'
      preLoaderRoute: typeof PrivacyLegacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookie-policy': {
      id: '/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/cookie-policy'
      preLoaderRoute: typeof CookiePolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm-email': {
      id: '/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof ConfirmEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/': {
      id: '/signup/'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/$signup_type': {
      id: '/signup/$signup_type'
      path: '/signup/$signup_type'
      fullPath: '/signup/$signup_type'
      preLoaderRoute: typeof SignupSignup_typeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/return/$subpage': {
      id: '/return/$subpage'
      path: '/return/$subpage'
      fullPath: '/return/$subpage'
      preLoaderRoute: typeof ReturnSubpageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/$subpage': {
      id: '/login/$subpage'
      path: '/login/$subpage'
      fullPath: '/login/$subpage'
      preLoaderRoute: typeof LoginSubpageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$post_slug': {
      id: '/blog/$post_slug'
      path: '/blog/$post_slug'
      fullPath: '/blog/$post_slug'
      preLoaderRoute: typeof BlogPost_slugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/tournaments-choice': {
      id: '/_app/tournaments-choice'
      path: '/tournaments-choice'
      fullPath: '/tournaments-choice'
      preLoaderRoute: typeof AppTournamentsChoiceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/global-ranking-league': {
      id: '/_app/global-ranking-league'
      path: '/global-ranking-league'
      fullPath: '/global-ranking-league'
      preLoaderRoute: typeof AppGlobalRankingLeagueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coming-soon': {
      id: '/_app/coming-soon'
      path: '/coming-soon'
      fullPath: '/coming-soon'
      preLoaderRoute: typeof AppComingSoonRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tournaments/': {
      id: '/_app/tournaments/'
      path: '/tournaments'
      fullPath: '/tournaments'
      preLoaderRoute: typeof AppTournamentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tournaments-ranking/': {
      id: '/_app/tournaments-ranking/'
      path: '/tournaments-ranking'
      fullPath: '/tournaments-ranking'
      preLoaderRoute: typeof AppTournamentsRankingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tournaments-ranking-tables/': {
      id: '/_app/tournaments-ranking-tables/'
      path: '/tournaments-ranking-tables'
      fullPath: '/tournaments-ranking-tables'
      preLoaderRoute: typeof AppTournamentsRankingTablesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/running/': {
      id: '/_app/running/'
      path: '/running'
      fullPath: '/running'
      preLoaderRoute: typeof AppRunningIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/': {
      id: '/_app/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/players/': {
      id: '/_app/players/'
      path: '/players'
      fullPath: '/players'
      preLoaderRoute: typeof AppPlayersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages/': {
      id: '/_app/messages/'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/': {
      id: '/_app/marketplace/'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof AppMarketplaceIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leagues/': {
      id: '/_app/leagues/'
      path: '/leagues'
      fullPath: '/leagues'
      preLoaderRoute: typeof AppLeaguesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/communities/': {
      id: '/_app/communities/'
      path: '/communities'
      fullPath: '/communities'
      preLoaderRoute: typeof AppCommunitiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clubs/': {
      id: '/_app/clubs/'
      path: '/clubs'
      fullPath: '/clubs'
      preLoaderRoute: typeof AppClubsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/abilities/': {
      id: '/_app/abilities/'
      path: '/abilities'
      fullPath: '/abilities'
      preLoaderRoute: typeof AppAbilitiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tournaments/$tournament_uid': {
      id: '/_app/tournaments/$tournament_uid'
      path: '/tournaments/$tournament_uid'
      fullPath: '/tournaments/$tournament_uid'
      preLoaderRoute: typeof AppTournamentsTournament_uidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tournaments-ranking/$ranking_group_uid': {
      id: '/_app/tournaments-ranking/$ranking_group_uid'
      path: '/tournaments-ranking/$ranking_group_uid'
      fullPath: '/tournaments-ranking/$ranking_group_uid'
      preLoaderRoute: typeof AppTournamentsRankingRanking_group_uidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tournaments-ranking-tables/$ranking_group_uid': {
      id: '/_app/tournaments-ranking-tables/$ranking_group_uid'
      path: '/tournaments-ranking-tables/$ranking_group_uid'
      fullPath: '/tournaments-ranking-tables/$ranking_group_uid'
      preLoaderRoute: typeof AppTournamentsRankingTablesRanking_group_uidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/running/upload': {
      id: '/_app/running/upload'
      path: '/running/upload'
      fullPath: '/running/upload'
      preLoaderRoute: typeof AppRunningUploadRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/upcoming-games': {
      id: '/_app/profile/upcoming-games'
      path: '/profile/upcoming-games'
      fullPath: '/profile/upcoming-games'
      preLoaderRoute: typeof AppProfileUpcomingGamesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/recent-matches': {
      id: '/_app/profile/recent-matches'
      path: '/profile/recent-matches'
      fullPath: '/profile/recent-matches'
      preLoaderRoute: typeof AppProfileRecentMatchesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/messages': {
      id: '/_app/profile/messages'
      path: '/profile/messages'
      fullPath: '/profile/messages'
      preLoaderRoute: typeof AppProfileMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/players/$player_uid': {
      id: '/_app/players/$player_uid'
      path: '/players/$player_uid'
      fullPath: '/players/$player_uid'
      preLoaderRoute: typeof AppPlayersPlayer_uidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master/users': {
      id: '/_app/master/users'
      path: '/master/users'
      fullPath: '/master/users'
      preLoaderRoute: typeof AppMasterUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master/subscriptions': {
      id: '/_app/master/subscriptions'
      path: '/master/subscriptions'
      fullPath: '/master/subscriptions'
      preLoaderRoute: typeof AppMasterSubscriptionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master/posts': {
      id: '/_app/master/posts'
      path: '/master/posts'
      fullPath: '/master/posts'
      preLoaderRoute: typeof AppMasterPostsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master/players': {
      id: '/_app/master/players'
      path: '/master/players'
      fullPath: '/master/players'
      preLoaderRoute: typeof AppMasterPlayersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/$category': {
      id: '/_app/marketplace/$category'
      path: '/marketplace/$category'
      fullPath: '/marketplace/$category'
      preLoaderRoute: typeof AppMarketplaceCategoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leagues/$league_uid': {
      id: '/_app/leagues/$league_uid'
      path: '/leagues/$league_uid'
      fullPath: '/leagues/$league_uid'
      preLoaderRoute: typeof AppLeaguesLeague_uidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/courts-booking/$': {
      id: '/_app/courts-booking/$'
      path: '/courts-booking/$'
      fullPath: '/courts-booking/$'
      preLoaderRoute: typeof AppCourtsBookingSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profiles/$player_uid/': {
      id: '/_app/profiles/$player_uid/'
      path: '/profiles/$player_uid'
      fullPath: '/profiles/$player_uid'
      preLoaderRoute: typeof AppProfilesPlayer_uidIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizer/coaches/': {
      id: '/_app/organizer/coaches/'
      path: '/organizer/coaches'
      fullPath: '/organizer/coaches'
      preLoaderRoute: typeof AppOrganizerCoachesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizer/assessments/': {
      id: '/_app/organizer/assessments/'
      path: '/organizer/assessments'
      fullPath: '/organizer/assessments'
      preLoaderRoute: typeof AppOrganizerAssessmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/communities/$community_uid/': {
      id: '/_app/communities/$community_uid/'
      path: '/communities/$community_uid'
      fullPath: '/communities/$community_uid'
      preLoaderRoute: typeof AppCommunitiesCommunity_uidIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clubs/$club_uid/': {
      id: '/_app/clubs/$club_uid/'
      path: '/clubs/$club_uid'
      fullPath: '/clubs/$club_uid'
      preLoaderRoute: typeof AppClubsClub_uidIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/abilities/$assessment_uid/': {
      id: '/_app/abilities/$assessment_uid/'
      path: '/abilities/$assessment_uid'
      fullPath: '/abilities/$assessment_uid'
      preLoaderRoute: typeof AppAbilitiesAssessment_uidIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tournaments/$tournament_uid/$page': {
      id: '/_app/tournaments/$tournament_uid/$page'
      path: '/$page'
      fullPath: '/tournaments/$tournament_uid/$page'
      preLoaderRoute: typeof AppTournamentsTournament_uidPageRouteImport
      parentRoute: typeof AppTournamentsTournament_uidRoute
    }
    '/_app/running/results/$import_uid': {
      id: '/_app/running/results/$import_uid'
      path: '/running/results/$import_uid'
      fullPath: '/running/results/$import_uid'
      preLoaderRoute: typeof AppRunningResultsImport_uidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/running/leaderboards/$ranking_group_uid': {
      id: '/_app/running/leaderboards/$ranking_group_uid'
      path: '/running/leaderboards/$ranking_group_uid'
      fullPath: '/running/leaderboards/$ranking_group_uid'
      preLoaderRoute: typeof AppRunningLeaderboardsRanking_group_uidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/running/leaderboards-results/$ranking_group_uid': {
      id: '/_app/running/leaderboards-results/$ranking_group_uid'
      path: '/running/leaderboards-results/$ranking_group_uid'
      fullPath: '/running/leaderboards-results/$ranking_group_uid'
      preLoaderRoute: typeof AppRunningLeaderboardsResultsRanking_group_uidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profiles/$player_uid/stats': {
      id: '/_app/profiles/$player_uid/stats'
      path: '/profiles/$player_uid/stats'
      fullPath: '/profiles/$player_uid/stats'
      preLoaderRoute: typeof AppProfilesPlayer_uidStatsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profiles/$player_uid/edit': {
      id: '/_app/profiles/$player_uid/edit'
      path: '/profiles/$player_uid/edit'
      fullPath: '/profiles/$player_uid/edit'
      preLoaderRoute: typeof AppProfilesPlayer_uidEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profiles/$player_uid/dashboard': {
      id: '/_app/profiles/$player_uid/dashboard'
      path: '/profiles/$player_uid/dashboard'
      fullPath: '/profiles/$player_uid/dashboard'
      preLoaderRoute: typeof AppProfilesPlayer_uidDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/games/$game_uid': {
      id: '/_app/profile/games/$game_uid'
      path: '/profile/games/$game_uid'
      fullPath: '/profile/games/$game_uid'
      preLoaderRoute: typeof AppProfileGamesGame_uidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizer/coaches/$coach_uid': {
      id: '/_app/organizer/coaches/$coach_uid'
      path: '/organizer/coaches/$coach_uid'
      fullPath: '/organizer/coaches/$coach_uid'
      preLoaderRoute: typeof AppOrganizerCoachesCoach_uidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/master/users/$user_uid': {
      id: '/_app/master/users/$user_uid'
      path: '/$user_uid'
      fullPath: '/master/users/$user_uid'
      preLoaderRoute: typeof AppMasterUsersUser_uidRouteImport
      parentRoute: typeof AppMasterUsersRoute
    }
    '/_app/master/subscriptions/$post_uid': {
      id: '/_app/master/subscriptions/$post_uid'
      path: '/$post_uid'
      fullPath: '/master/subscriptions/$post_uid'
      preLoaderRoute: typeof AppMasterSubscriptionsPost_uidRouteImport
      parentRoute: typeof AppMasterSubscriptionsRoute
    }
    '/_app/master/posts/$post_uid': {
      id: '/_app/master/posts/$post_uid'
      path: '/$post_uid'
      fullPath: '/master/posts/$post_uid'
      preLoaderRoute: typeof AppMasterPostsPost_uidRouteImport
      parentRoute: typeof AppMasterPostsRoute
    }
    '/_app/master/players/$player_uid': {
      id: '/_app/master/players/$player_uid'
      path: '/$player_uid'
      fullPath: '/master/players/$player_uid'
      preLoaderRoute: typeof AppMasterPlayersPlayer_uidRouteImport
      parentRoute: typeof AppMasterPlayersRoute
    }
    '/_app/leagues/$league_uid/$page': {
      id: '/_app/leagues/$league_uid/$page'
      path: '/$page'
      fullPath: '/leagues/$league_uid/$page'
      preLoaderRoute: typeof AppLeaguesLeague_uidPageRouteImport
      parentRoute: typeof AppLeaguesLeague_uidRoute
    }
    '/_app/communities/$community_uid/edit': {
      id: '/_app/communities/$community_uid/edit'
      path: '/communities/$community_uid/edit'
      fullPath: '/communities/$community_uid/edit'
      preLoaderRoute: typeof AppCommunitiesCommunity_uidEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clubs/$club_uid/edit': {
      id: '/_app/clubs/$club_uid/edit'
      path: '/clubs/$club_uid/edit'
      fullPath: '/clubs/$club_uid/edit'
      preLoaderRoute: typeof AppClubsClub_uidEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clubs/$club_uid/courts-booking': {
      id: '/_app/clubs/$club_uid/courts-booking'
      path: '/clubs/$club_uid/courts-booking'
      fullPath: '/clubs/$club_uid/courts-booking'
      preLoaderRoute: typeof AppClubsClub_uidCourtsBookingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clubs/$club_uid/bookings': {
      id: '/_app/clubs/$club_uid/bookings'
      path: '/clubs/$club_uid/bookings'
      fullPath: '/clubs/$club_uid/bookings'
      preLoaderRoute: typeof AppClubsClub_uidBookingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clubs/$club_uid/courts/': {
      id: '/_app/clubs/$club_uid/courts/'
      path: '/clubs/$club_uid/courts'
      fullPath: '/clubs/$club_uid/courts'
      preLoaderRoute: typeof AppClubsClub_uidCourtsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tournaments/$tournament_uid/$page/$subpage': {
      id: '/_app/tournaments/$tournament_uid/$page/$subpage'
      path: '/$subpage'
      fullPath: '/tournaments/$tournament_uid/$page/$subpage'
      preLoaderRoute: typeof AppTournamentsTournament_uidPageSubpageRouteImport
      parentRoute: typeof AppTournamentsTournament_uidPageRoute
    }
    '/_app/leagues/$league_uid/player/$player_uid': {
      id: '/_app/leagues/$league_uid/player/$player_uid'
      path: '/player/$player_uid'
      fullPath: '/leagues/$league_uid/player/$player_uid'
      preLoaderRoute: typeof AppLeaguesLeague_uidPlayerPlayer_uidRouteImport
      parentRoute: typeof AppLeaguesLeague_uidRoute
    }
    '/_app/leagues/$league_uid/game/$game_uid': {
      id: '/_app/leagues/$league_uid/game/$game_uid'
      path: '/game/$game_uid'
      fullPath: '/leagues/$league_uid/game/$game_uid'
      preLoaderRoute: typeof AppLeaguesLeague_uidGameGame_uidRouteImport
      parentRoute: typeof AppLeaguesLeague_uidRoute
    }
    '/_app/leagues/$league_uid/$page/$subpage': {
      id: '/_app/leagues/$league_uid/$page/$subpage'
      path: '/$subpage'
      fullPath: '/leagues/$league_uid/$page/$subpage'
      preLoaderRoute: typeof AppLeaguesLeague_uidPageSubpageRouteImport
      parentRoute: typeof AppLeaguesLeague_uidPageRoute
    }
    '/_app/clubs/$club_uid/courts/$court_uid': {
      id: '/_app/clubs/$club_uid/courts/$court_uid'
      path: '/clubs/$club_uid/courts/$court_uid'
      fullPath: '/clubs/$club_uid/courts/$court_uid'
      preLoaderRoute: typeof AppClubsClub_uidCourtsCourt_uidRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppLeaguesLeague_uidPageRouteChildren {
  AppLeaguesLeague_uidPageSubpageRoute: typeof AppLeaguesLeague_uidPageSubpageRoute
}

const AppLeaguesLeague_uidPageRouteChildren: AppLeaguesLeague_uidPageRouteChildren =
  {
    AppLeaguesLeague_uidPageSubpageRoute: AppLeaguesLeague_uidPageSubpageRoute,
  }

const AppLeaguesLeague_uidPageRouteWithChildren =
  AppLeaguesLeague_uidPageRoute._addFileChildren(
    AppLeaguesLeague_uidPageRouteChildren,
  )

interface AppLeaguesLeague_uidRouteChildren {
  AppLeaguesLeague_uidPageRoute: typeof AppLeaguesLeague_uidPageRouteWithChildren
  AppLeaguesLeague_uidGameGame_uidRoute: typeof AppLeaguesLeague_uidGameGame_uidRoute
  AppLeaguesLeague_uidPlayerPlayer_uidRoute: typeof AppLeaguesLeague_uidPlayerPlayer_uidRoute
}

const AppLeaguesLeague_uidRouteChildren: AppLeaguesLeague_uidRouteChildren = {
  AppLeaguesLeague_uidPageRoute: AppLeaguesLeague_uidPageRouteWithChildren,
  AppLeaguesLeague_uidGameGame_uidRoute: AppLeaguesLeague_uidGameGame_uidRoute,
  AppLeaguesLeague_uidPlayerPlayer_uidRoute:
    AppLeaguesLeague_uidPlayerPlayer_uidRoute,
}

const AppLeaguesLeague_uidRouteWithChildren =
  AppLeaguesLeague_uidRoute._addFileChildren(AppLeaguesLeague_uidRouteChildren)

interface AppMasterPlayersRouteChildren {
  AppMasterPlayersPlayer_uidRoute: typeof AppMasterPlayersPlayer_uidRoute
}

const AppMasterPlayersRouteChildren: AppMasterPlayersRouteChildren = {
  AppMasterPlayersPlayer_uidRoute: AppMasterPlayersPlayer_uidRoute,
}

const AppMasterPlayersRouteWithChildren =
  AppMasterPlayersRoute._addFileChildren(AppMasterPlayersRouteChildren)

interface AppMasterPostsRouteChildren {
  AppMasterPostsPost_uidRoute: typeof AppMasterPostsPost_uidRoute
}

const AppMasterPostsRouteChildren: AppMasterPostsRouteChildren = {
  AppMasterPostsPost_uidRoute: AppMasterPostsPost_uidRoute,
}

const AppMasterPostsRouteWithChildren = AppMasterPostsRoute._addFileChildren(
  AppMasterPostsRouteChildren,
)

interface AppMasterSubscriptionsRouteChildren {
  AppMasterSubscriptionsPost_uidRoute: typeof AppMasterSubscriptionsPost_uidRoute
}

const AppMasterSubscriptionsRouteChildren: AppMasterSubscriptionsRouteChildren =
  {
    AppMasterSubscriptionsPost_uidRoute: AppMasterSubscriptionsPost_uidRoute,
  }

const AppMasterSubscriptionsRouteWithChildren =
  AppMasterSubscriptionsRoute._addFileChildren(
    AppMasterSubscriptionsRouteChildren,
  )

interface AppMasterUsersRouteChildren {
  AppMasterUsersUser_uidRoute: typeof AppMasterUsersUser_uidRoute
}

const AppMasterUsersRouteChildren: AppMasterUsersRouteChildren = {
  AppMasterUsersUser_uidRoute: AppMasterUsersUser_uidRoute,
}

const AppMasterUsersRouteWithChildren = AppMasterUsersRoute._addFileChildren(
  AppMasterUsersRouteChildren,
)

interface AppTournamentsTournament_uidPageRouteChildren {
  AppTournamentsTournament_uidPageSubpageRoute: typeof AppTournamentsTournament_uidPageSubpageRoute
}

const AppTournamentsTournament_uidPageRouteChildren: AppTournamentsTournament_uidPageRouteChildren =
  {
    AppTournamentsTournament_uidPageSubpageRoute:
      AppTournamentsTournament_uidPageSubpageRoute,
  }

const AppTournamentsTournament_uidPageRouteWithChildren =
  AppTournamentsTournament_uidPageRoute._addFileChildren(
    AppTournamentsTournament_uidPageRouteChildren,
  )

interface AppTournamentsTournament_uidRouteChildren {
  AppTournamentsTournament_uidPageRoute: typeof AppTournamentsTournament_uidPageRouteWithChildren
}

const AppTournamentsTournament_uidRouteChildren: AppTournamentsTournament_uidRouteChildren =
  {
    AppTournamentsTournament_uidPageRoute:
      AppTournamentsTournament_uidPageRouteWithChildren,
  }

const AppTournamentsTournament_uidRouteWithChildren =
  AppTournamentsTournament_uidRoute._addFileChildren(
    AppTournamentsTournament_uidRouteChildren,
  )

interface AppRouteChildren {
  AppComingSoonRoute: typeof AppComingSoonRoute
  AppGlobalRankingLeagueRoute: typeof AppGlobalRankingLeagueRoute
  AppTournamentsChoiceRoute: typeof AppTournamentsChoiceRoute
  AppCourtsBookingSplatRoute: typeof AppCourtsBookingSplatRoute
  AppLeaguesLeague_uidRoute: typeof AppLeaguesLeague_uidRouteWithChildren
  AppMarketplaceCategoryRoute: typeof AppMarketplaceCategoryRoute
  AppMasterPlayersRoute: typeof AppMasterPlayersRouteWithChildren
  AppMasterPostsRoute: typeof AppMasterPostsRouteWithChildren
  AppMasterSubscriptionsRoute: typeof AppMasterSubscriptionsRouteWithChildren
  AppMasterUsersRoute: typeof AppMasterUsersRouteWithChildren
  AppPlayersPlayer_uidRoute: typeof AppPlayersPlayer_uidRoute
  AppProfileMessagesRoute: typeof AppProfileMessagesRoute
  AppProfileRecentMatchesRoute: typeof AppProfileRecentMatchesRoute
  AppProfileUpcomingGamesRoute: typeof AppProfileUpcomingGamesRoute
  AppRunningUploadRoute: typeof AppRunningUploadRoute
  AppTournamentsRankingTablesRanking_group_uidRoute: typeof AppTournamentsRankingTablesRanking_group_uidRoute
  AppTournamentsRankingRanking_group_uidRoute: typeof AppTournamentsRankingRanking_group_uidRoute
  AppTournamentsTournament_uidRoute: typeof AppTournamentsTournament_uidRouteWithChildren
  AppAbilitiesIndexRoute: typeof AppAbilitiesIndexRoute
  AppClubsIndexRoute: typeof AppClubsIndexRoute
  AppCommunitiesIndexRoute: typeof AppCommunitiesIndexRoute
  AppLeaguesIndexRoute: typeof AppLeaguesIndexRoute
  AppMarketplaceIndexRoute: typeof AppMarketplaceIndexRoute
  AppMessagesIndexRoute: typeof AppMessagesIndexRoute
  AppPlayersIndexRoute: typeof AppPlayersIndexRoute
  AppProfileIndexRoute: typeof AppProfileIndexRoute
  AppRunningIndexRoute: typeof AppRunningIndexRoute
  AppTournamentsRankingTablesIndexRoute: typeof AppTournamentsRankingTablesIndexRoute
  AppTournamentsRankingIndexRoute: typeof AppTournamentsRankingIndexRoute
  AppTournamentsIndexRoute: typeof AppTournamentsIndexRoute
  AppClubsClub_uidBookingsRoute: typeof AppClubsClub_uidBookingsRoute
  AppClubsClub_uidCourtsBookingRoute: typeof AppClubsClub_uidCourtsBookingRoute
  AppClubsClub_uidEditRoute: typeof AppClubsClub_uidEditRoute
  AppCommunitiesCommunity_uidEditRoute: typeof AppCommunitiesCommunity_uidEditRoute
  AppOrganizerCoachesCoach_uidRoute: typeof AppOrganizerCoachesCoach_uidRoute
  AppProfileGamesGame_uidRoute: typeof AppProfileGamesGame_uidRoute
  AppProfilesPlayer_uidDashboardRoute: typeof AppProfilesPlayer_uidDashboardRoute
  AppProfilesPlayer_uidEditRoute: typeof AppProfilesPlayer_uidEditRoute
  AppProfilesPlayer_uidStatsRoute: typeof AppProfilesPlayer_uidStatsRoute
  AppRunningLeaderboardsResultsRanking_group_uidRoute: typeof AppRunningLeaderboardsResultsRanking_group_uidRoute
  AppRunningLeaderboardsRanking_group_uidRoute: typeof AppRunningLeaderboardsRanking_group_uidRoute
  AppRunningResultsImport_uidRoute: typeof AppRunningResultsImport_uidRoute
  AppAbilitiesAssessment_uidIndexRoute: typeof AppAbilitiesAssessment_uidIndexRoute
  AppClubsClub_uidIndexRoute: typeof AppClubsClub_uidIndexRoute
  AppCommunitiesCommunity_uidIndexRoute: typeof AppCommunitiesCommunity_uidIndexRoute
  AppOrganizerAssessmentsIndexRoute: typeof AppOrganizerAssessmentsIndexRoute
  AppOrganizerCoachesIndexRoute: typeof AppOrganizerCoachesIndexRoute
  AppProfilesPlayer_uidIndexRoute: typeof AppProfilesPlayer_uidIndexRoute
  AppClubsClub_uidCourtsCourt_uidRoute: typeof AppClubsClub_uidCourtsCourt_uidRoute
  AppClubsClub_uidCourtsIndexRoute: typeof AppClubsClub_uidCourtsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppComingSoonRoute: AppComingSoonRoute,
  AppGlobalRankingLeagueRoute: AppGlobalRankingLeagueRoute,
  AppTournamentsChoiceRoute: AppTournamentsChoiceRoute,
  AppCourtsBookingSplatRoute: AppCourtsBookingSplatRoute,
  AppLeaguesLeague_uidRoute: AppLeaguesLeague_uidRouteWithChildren,
  AppMarketplaceCategoryRoute: AppMarketplaceCategoryRoute,
  AppMasterPlayersRoute: AppMasterPlayersRouteWithChildren,
  AppMasterPostsRoute: AppMasterPostsRouteWithChildren,
  AppMasterSubscriptionsRoute: AppMasterSubscriptionsRouteWithChildren,
  AppMasterUsersRoute: AppMasterUsersRouteWithChildren,
  AppPlayersPlayer_uidRoute: AppPlayersPlayer_uidRoute,
  AppProfileMessagesRoute: AppProfileMessagesRoute,
  AppProfileRecentMatchesRoute: AppProfileRecentMatchesRoute,
  AppProfileUpcomingGamesRoute: AppProfileUpcomingGamesRoute,
  AppRunningUploadRoute: AppRunningUploadRoute,
  AppTournamentsRankingTablesRanking_group_uidRoute:
    AppTournamentsRankingTablesRanking_group_uidRoute,
  AppTournamentsRankingRanking_group_uidRoute:
    AppTournamentsRankingRanking_group_uidRoute,
  AppTournamentsTournament_uidRoute:
    AppTournamentsTournament_uidRouteWithChildren,
  AppAbilitiesIndexRoute: AppAbilitiesIndexRoute,
  AppClubsIndexRoute: AppClubsIndexRoute,
  AppCommunitiesIndexRoute: AppCommunitiesIndexRoute,
  AppLeaguesIndexRoute: AppLeaguesIndexRoute,
  AppMarketplaceIndexRoute: AppMarketplaceIndexRoute,
  AppMessagesIndexRoute: AppMessagesIndexRoute,
  AppPlayersIndexRoute: AppPlayersIndexRoute,
  AppProfileIndexRoute: AppProfileIndexRoute,
  AppRunningIndexRoute: AppRunningIndexRoute,
  AppTournamentsRankingTablesIndexRoute: AppTournamentsRankingTablesIndexRoute,
  AppTournamentsRankingIndexRoute: AppTournamentsRankingIndexRoute,
  AppTournamentsIndexRoute: AppTournamentsIndexRoute,
  AppClubsClub_uidBookingsRoute: AppClubsClub_uidBookingsRoute,
  AppClubsClub_uidCourtsBookingRoute: AppClubsClub_uidCourtsBookingRoute,
  AppClubsClub_uidEditRoute: AppClubsClub_uidEditRoute,
  AppCommunitiesCommunity_uidEditRoute: AppCommunitiesCommunity_uidEditRoute,
  AppOrganizerCoachesCoach_uidRoute: AppOrganizerCoachesCoach_uidRoute,
  AppProfileGamesGame_uidRoute: AppProfileGamesGame_uidRoute,
  AppProfilesPlayer_uidDashboardRoute: AppProfilesPlayer_uidDashboardRoute,
  AppProfilesPlayer_uidEditRoute: AppProfilesPlayer_uidEditRoute,
  AppProfilesPlayer_uidStatsRoute: AppProfilesPlayer_uidStatsRoute,
  AppRunningLeaderboardsResultsRanking_group_uidRoute:
    AppRunningLeaderboardsResultsRanking_group_uidRoute,
  AppRunningLeaderboardsRanking_group_uidRoute:
    AppRunningLeaderboardsRanking_group_uidRoute,
  AppRunningResultsImport_uidRoute: AppRunningResultsImport_uidRoute,
  AppAbilitiesAssessment_uidIndexRoute: AppAbilitiesAssessment_uidIndexRoute,
  AppClubsClub_uidIndexRoute: AppClubsClub_uidIndexRoute,
  AppCommunitiesCommunity_uidIndexRoute: AppCommunitiesCommunity_uidIndexRoute,
  AppOrganizerAssessmentsIndexRoute: AppOrganizerAssessmentsIndexRoute,
  AppOrganizerCoachesIndexRoute: AppOrganizerCoachesIndexRoute,
  AppProfilesPlayer_uidIndexRoute: AppProfilesPlayer_uidIndexRoute,
  AppClubsClub_uidCourtsCourt_uidRoute: AppClubsClub_uidCourtsCourt_uidRoute,
  AppClubsClub_uidCourtsIndexRoute: AppClubsClub_uidCourtsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AboutRoute: AboutRoute,
  ConfirmEmailRoute: ConfirmEmailRoute,
  ContactRoute: ContactRoute,
  CookiePolicyRoute: CookiePolicyRoute,
  FaqRoute: FaqRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  PrivacyLegacyRoute: PrivacyLegacyRoute,
  TermsRoute: TermsRoute,
  BlogPost_slugRoute: BlogPost_slugRoute,
  LoginSubpageRoute: LoginSubpageRoute,
  ReturnSubpageRoute: ReturnSubpageRoute,
  SignupSignup_typeRoute: SignupSignup_typeRoute,
  BlogIndexRoute: BlogIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  SignupIndexRoute: SignupIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
